import { getResData, httpClient } from 'utils';
import { INITIATIVES_API_PATHS } from './consts';
import {
    CreateInitiativeDTO,
    UpdateInitiativeDTO,
    InitiativeDTO,
    InitiativeListItemDTO,
    InitiativeOverviewDTO,
    InitiativeTypeDTO,
    InitiativeCategoryDTO,
    InitiativeKpiDTO,
    InitiativeKpiUnitDTO,
} from './types';

export const getInitiatives = (): Promise<InitiativeListItemDTO[]> =>
    httpClient.get<InitiativeListItemDTO[]>(INITIATIVES_API_PATHS.INITIATIVES).then(getResData);

export const getInitiative = (id: number): Promise<InitiativeDTO> =>
    httpClient.get<InitiativeDTO>(`${INITIATIVES_API_PATHS.INITIATIVES}/${id}`).then(getResData);

export const createInitiative = (body: CreateInitiativeDTO): Promise<InitiativeDTO> =>
    httpClient.post<InitiativeDTO>(INITIATIVES_API_PATHS.INITIATIVES, body).then(getResData);

export const updateInitiative = (id: number, body: UpdateInitiativeDTO): Promise<InitiativeDTO> =>
    httpClient.put<InitiativeDTO>(`${INITIATIVES_API_PATHS.INITIATIVES}/${id}`, body).then(getResData);

export const deleteInitiatives = (ids: number[]): Promise<void> =>
    httpClient.delete(`${INITIATIVES_API_PATHS.INITIATIVES}?ids=${ids.join(',')}`).then(getResData);

export const getInitiativeTypes = (): Promise<InitiativeTypeDTO[]> =>
    httpClient.get<InitiativeTypeDTO[]>(INITIATIVES_API_PATHS.INITIATIVE_TYPES).then(getResData);

export const getInitiativeCategories = (): Promise<InitiativeCategoryDTO[]> =>
    httpClient.get<InitiativeCategoryDTO[]>(INITIATIVES_API_PATHS.INITIATIVE_CATEGORIES).then(getResData);

export const getInitiativeKpiOptions = (): Promise<InitiativeKpiDTO[]> =>
    httpClient.get<InitiativeKpiDTO[]>(INITIATIVES_API_PATHS.INITIATIVE_KPIS).then(getResData);

export const getInitiativeKpiUnits = (): Promise<InitiativeKpiUnitDTO> =>
    httpClient.get<InitiativeKpiUnitDTO>(INITIATIVES_API_PATHS.INITIATIVE_KPI_UNITS).then(getResData);

export const getInitiativesOverview = (): Promise<InitiativeOverviewDTO> =>
    httpClient.get<InitiativeOverviewDTO>(INITIATIVES_API_PATHS.INITIATIVE_OVERVIEW).then(getResData);

export const exportInitiatives = (): Promise<Blob> =>
    httpClient.get(INITIATIVES_API_PATHS.INITIATIVE_EXPORT, { responseType: 'blob' }).then((response) => response.data);
